import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import Loder from "../components/loder";
import ReactPixel from "react-facebook-pixel";
import rzpsvg from "../assets/plans/razorpay-logo.5cdb58df 1.svg";
import stripesvg from "../assets/plans/Group.svg";
import razorpayPaymentHelper from "../helpers/RazorpayPaymentHelper";
import SubscriptionMessageModal from "../components/MessageModal/SubscriptionMessageModal";
import {
  ApplyCuponCode,
  CaptureStripePayment,
  FetchAllPlan,
  getPlan,
} from "../redux/actions/PlanAction";
import { useHistory } from "react-router";
import { currencyConverter } from "../helpers/planPrice";
import StripePaymentHandler from "../components/StripePaymentHandler";
import { openInNewTab } from "../helpers/LoadDoc";
import { SubscribeUser } from "../redux/actions/UserAction";
import Swal from "sweetalert2";
import { getDevice } from "../helpers/PageHelper";
import { initGA, initPixel } from "../helpers/CampaignEvents";

const PlanAndPrices = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();

  const [content, setContent] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);
  const [duration, setDuration] = useState("15min");
  const [day, setDay] = useState("1");
  const [month, setMonth] = useState("6");
  const [discount, setDiscount] = useState(35);
  const [wallet, setWallet] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0);
  const [usedWalletAmount, setUsedWalletAmount] = useState(0);
  const [usdPrice, setUSDprice] = useState(0);

  const [cupon, setCupon] = useState(false);
  const [cuponCode, setCuponCode] = useState("");
  const [cuponAmount, setCuponAmount] = useState(0);
  const [cuponLoder, setCuponLoder] = useState(false);

  const [show, setShow] = useState(false);
  const [subscribeLoder, setSubscribeLoder] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("Razorpay");

  //calculation
  const [grandTotal, setGrandTotal] = useState("");
  const [gstAmount, setGstAmount] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [cupondiscount, setCuponDiscount] = useState("");
  const [cuponapplied, setCuponapplied] = useState("");

  // const influencerCuponCode = localStorage.getItem("INFLUENCER_CODE")
  const UserLocaldata = JSON.parse(localStorage.getItem("USER"));

  //redux stote
  const Plans = useSelector((state) => state.PlanReducer.plans);
  const userWallet = useSelector(
    (state) => state.UserReducer.learnerWalletHistory
  );
  const User = useSelector((state) => state.UserReducer.user);
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const currency = JSON.parse(localStorage.getItem("CURRENCY"));
  const addPageUser = JSON.parse(localStorage.getItem("ADD_PAGE_USER"));
  const token = JSON.parse(localStorage.getItem("TOKEN"))
  const abortController = React.useRef()
  useEffect(() => {
    initPixel();
    initGA();
    const onSuccess = (data) => {
      console.log(data);
      setContent(data);
    };
    dispatch(getPlan(onSuccess));
    dispatch(FetchAllPlan());

    if (userWallet) {
      userWallet.slice(0, 1).map((data) => {
        //console.log(data.closingBalance)
        setWalletAmount(data.closingBalance);
      });
    }
    setUSDprice(currency ? currency : 0);
  }, []);


  useEffect(() => {
    if (cupon) {

      setCuponLoder(true);
      if (!cuponCode) {
              openSnackbar("Refferal code can't be empty");
              setCuponapplied("Refferal code can't be empty");
              setCuponLoder(false);
              return;
            }

      // If there is a pending fetch request with associated AbortController, abort
      if (abortController.current) {
        abortController.current.abort()
      }
      // Assign a new AbortController for the latest fetch to our useRef variable
      abortController.current = new AbortController()
      const { signal } = abortController.current
      const data = {
        cupon: cuponCode,
        subject: "English",
        planId: planDetails?._id,
        months: month
      };
      var options = {
        method: "post",
        headers: {
          'Content-type': 'application/json',
          'x-access-token': token,
          'timezone': time_zone.timezone
        },
        signal,
        body: JSON.stringify(data),
      }

      // (async()=>{
      //   try{
      //   const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options, {signal});
      //   // Awaiting response.json()
      //   const resData = await response.json();
      //   console.log(resData)
      //   } catch(err) { 
      //     console.error(err)
      //   }
      // })()

      //   (async function() {
      //     try {
      //         const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options, {signal});
      //         const json = await response.json();
      //         // setPosts(json.data.children.map(it => it.data));
      //         console.log(json)
      //     } catch (e) {
      //         console.error(e);
      //     }
      // })();
      // Same as before
      fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options, { signal }).then(async res => {
        // Rest of our fetching logic, same as before
        console.log(res)
        // Awaiting for fetch response and  
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options);
        // Awaiting response.json()
        const resData = await response.json();
        setCuponAmount(resData.influencers.cuponDiscount);
              setCuponCode(resData.influencers.refferalcode);
              setCupon(true);
              setCuponLoder(false);
              if (!UserLocaldata.influencer) {
                openSnackbar("Code applied successfully");
                setCuponapplied(resData.influencers.message)
              }
      })

    }
  }, [abortController, month, duration, day])


  // useEffect(()=>{
  //   if(cupon){
  //     setCuponLoder(true);

  //     if (!cuponCode) {
  //       openSnackbar("Refferal code can't be empty");
  //       setCuponapplied("Refferal code can't be empty");
  //       setCuponLoder(false);
  //       return;
  //     }

  //     const data = {
  //       cupon: cuponCode,
  //       subject:"English",
  //       planId:planDetails._id,
  //        months:month
  //     };
  //     const onSuccess = (data) => {
  //       console.log(data)
  //       setCuponAmount(data.cuponDiscount);
  //       setCuponCode(data.refferalcode);
  //       setCupon(true);
  //       setCuponLoder(false);
  //       if (!UserLocaldata.influencer) {
  //         openSnackbar("Code applied successfully");
  //         setCuponapplied(data.message)
  //       }
  //     };

  //     const onError = (msg) => {
  //       setCuponLoder(false);
  //       openSnackbar(msg);
  //       setCuponAmount(0);
  //       setCupon(false);
  //       setCuponCode("");
  //       setCuponapplied(msg);
  //     };

  //     dispatch(ApplyCuponCode(data, onSuccess, onError));
  //   }
  // },[month,duration,day])



  useEffect(() => {
    if (Plans) {
      Plans.map((data, i) => {
        if (
          data.classDuration === duration &&
          data.frequency === parseInt(day)
        ) {

          setPlanDetails(data);
        }
      });
    }
  }, [Plans]);

  useEffect(() => {
    if (cupon) {

      setCuponLoder(true);
      if (!cuponCode) {
              openSnackbar("Refferal code can't be empty");
              setCuponapplied("Refferal code can't be empty");
              setCuponLoder(false);
              return;
            }

      // If there is a pending fetch request with associated AbortController, abort
      if (abortController.current) {
        abortController.current.abort()
      }
      // Assign a new AbortController for the latest fetch to our useRef variable
      abortController.current = new AbortController()
      const { signal } = abortController.current
      // if (Plans) {
      //   Plans.map((data, i) => {
      //     if (
      //       data.classDuration === duration &&
      //       data.frequency === parseInt(day)
      //     ) {
  
      //       setPlanDetails(data);
      //     }
      //   });
      // }
      console.log(planDetails)
      const data = {
        cupon: cuponCode,
        subject: "English",
        planId: planDetails?._id,
        months: month
      };
    
      var options = {
        method: "post",
        headers: {
          'Content-type': 'application/json',
          'x-access-token': token,
          'timezone': time_zone.timezone
        },
        signal,
        body: JSON.stringify(data),
      }

      // (async()=>{
      //   try{
      //   const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options, {signal});
      //   // Awaiting response.json()
      //   const resData = await response.json();
      //   console.log(resData)
      //   } catch(err) { 
      //     console.error(err)
      //   }
      // })()

      //   (async function() {
      //     try {
      //         const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options, {signal});
      //         const json = await response.json();
      //         // setPosts(json.data.children.map(it => it.data));
      //         console.log(json)
      //     } catch (e) {
      //         console.error(e);
      //     }
      // })();
      // Same as before
      fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options, { signal }).then(async res => {
        // Rest of our fetching logic, same as before
        console.log(res)
        // Awaiting for fetch response and  
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/referral/getReferralOrOffer`, options);
        // Awaiting response.json()
        const resData = await response.json();
        console.log(resData)
        setCuponAmount(resData.influencers.cuponDiscount);
              setCuponCode(resData.influencers.refferalcode);
              setCupon(true);
              setCuponLoder(false);
              if (!UserLocaldata.influencer) {
                openSnackbar("Code applied successfully");
                setCuponapplied(resData.influencers.message)
              }
      })

    }
  }, [abortController, month, planDetails])


  // useEffect(()=>{
  //   if(cupon){
  //     setCuponLoder(true);

  //     if (!cuponCode) {
  //       openSnackbar("Refferal code can't be empty");
  //       setCuponapplied("Refferal code can't be empty");
  //       setCuponLoder(false);
  //       return;
  //     }

  //     const data = {
  //       cupon: cuponCode,
  //       subject:"English",
  //       planId:planDetails._id,
  //        months:month
  //     };
  //     const onSuccess = (data) => {
  //       console.log(data)
  //       setCuponAmount(data.cuponDiscount);
  //       setCuponCode(data.refferalcode);
  //       setCupon(true);
  //       setCuponLoder(false);
  //       if (!UserLocaldata.influencer) {
  //         openSnackbar("Code applied successfully");
  //         setCuponapplied(data.message)
  //       }
  //     };

  //     const onError = (msg) => {
  //       setCuponLoder(false);
  //       openSnackbar(msg);
  //       setCuponAmount(0);
  //       setCupon(false);
  //       setCuponCode("");
  //       setCuponapplied(msg);
  //     };

  //     dispatch(ApplyCuponCode(data, onSuccess, onError));
  //   }
  // },[month,duration,day])

  

  useEffect(() => {
    Plans.map((data, i) => {
      if (data.classDuration === duration && data.frequency === parseInt(day)) {
        console.log(data);
        setPlanDetails(data);
      }
    });
  }, [duration, day]);


  //check walet amount
  const handleCheck = () => {
    setWallet(!wallet);
    if (walletAmount == 0) {
      openSnackbar("You don't have any clapingo money in your wallet");
      setWallet(false);
    }
  };

  //cupon code

  const removeCupon = () => {
    setCuponAmount(0);
    setCupon(false);
    setCuponCode("");
    openSnackbar("Code removed successfully");
    setCuponapplied("")
  };

  const ApplyCupon = () => {
    setCuponLoder(true);

    if (!cuponCode) {
      openSnackbar("Refferal code can't be empty");
      setCuponapplied("Refferal code can't be empty");
      setCuponLoder(false);
      return;
    }

    const data = {
      cupon: cuponCode,
      subject: "English",
      planId: planDetails._id,
      months: month
    };
    const onSuccess = (data) => {
      setCuponAmount(data.cuponDiscount);
      setCuponCode(data.refferalcode);
      setCupon(true);
      setCuponLoder(false);
      if (!UserLocaldata.influencer) {
        openSnackbar("Code applied successfully");
        setCuponapplied(data.message)
      }
    };

    const onError = (msg) => {
      setCuponLoder(false);
      openSnackbar(msg);
      setCuponAmount(0);
      setCupon(false);
      setCuponCode("");
      setCuponapplied(msg);
    };

    dispatch(ApplyCuponCode(data, onSuccess, onError));
  };

  useEffect(() => {
    if (planDetails) {
      var total;
      var discountPrice = Math.round(
        ((planDetails.originalPrice * month) / 100) * discount
      );
      var cuponorwallet;
      var walletmoney = 0;

      //discount price
      if (cuponCode && wallet) {
        cuponorwallet = Math.round(
          ((planDetails.originalPrice * month - discountPrice - walletAmount) /
            100) *
          cuponAmount
        );
        walletmoney = walletAmount;
      } else if (wallet) {
        cuponorwallet = walletAmount;
      } else if (cuponCode) {
        cuponorwallet = Math.round(
          ((planDetails.originalPrice * month - discountPrice) / 100) *
          cuponAmount
        );
      } else if (!cuponCode && !wallet) {
        cuponorwallet = 0;
      }

      const orignalPrice30percent = Math.round(
        (planDetails.originalPrice * month * 30) / 100
      );

      if (orignalPrice30percent < walletAmount && wallet) {
        const wallet30percent = orignalPrice30percent;
        //(walletAmount*30) / 100
        cuponorwallet = Math.round(
          ((planDetails.originalPrice * month -
            discountPrice -
            wallet30percent) /
            100) *
          cuponAmount
        );
        setUsedWalletAmount(wallet30percent);
        walletmoney = wallet30percent;
      } else if (wallet) {
        setUsedWalletAmount(walletAmount);
      }

      setDiscountAmount(discountPrice);
      setCuponDiscount(cuponorwallet);
      //total amount
      total = Math.round(
        planDetails.originalPrice * month -
        discountPrice -
        cuponorwallet -
        walletmoney
      );
      //gst amount
      var gstamount = Math.round((total / 100) * 18);
      setGstAmount(gstamount);
      if (time_zone.country === "IN") {
        total = total + gstamount;
      } else {
        total = Math.round(((total) / usdPrice).toFixed(2) * 100);
      }

      setGrandTotal(total);
    }
  }, [month, planDetails, cupon, wallet]);

  // useEffect(() => {
  //   if (UserLocaldata.influencer) {
  //     if (cuponCode) {
  //       ApplyCupon();
  //     }
  //   }
  // }, [cuponCode]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //payment

  const SubscribeClapingo = (amount) => {
    setSubscribeLoder(true);
    const userCurrency = time_zone.country === "IN" ? "INR" : "USD";
    const userData = time_zone.timezone;
    const val = userData.split("/");
    const calculatedAmount = time_zone.country === "IN" ? amount : amount / 100;
    const data = {
      amount: amount,
      payment_capture: 1,
      currency: userCurrency,
      notes: {
        Name: User.name,
        Number: User.phoneNumber,
        Email: User.email,
        planId: planDetails._id,
        month: parseInt(month),
        zone1: val[0],
        zone2: val.length > 1 ? val[1] : undefined,
        paymentDetails: planDetails.courseName + "(from web)",
        currency: userCurrency,
        subscriptionName: planDetails.courseName,
        amount: calculatedAmount,
      },
      txndesc: planDetails.courseName,
    };

    const onSuccess = (rzpRes) => {
      var data = {
        learnerId: User._id,
        planId: planDetails._id,
        month: parseInt(month),
        zone1: val[0],
        zone2: val.length > 1 ? val[1] : undefined,
        paymentDetails: planDetails.courseName + "(from web)",
        order_id: rzpRes.razorpay_order_id,
        currency: userCurrency,
        subscriptionName: planDetails.courseName,
        transactionId: rzpRes.razorpay_order_id,
        amount: calculatedAmount,
        source: getDevice(),
      };
      if (cuponCode) {
        data["influencer"] = cuponCode;
        data["amountWithoutGST"] = Math.round(amount - amount * 0.18);
      }
      if (wallet) {
        data["isWallet"] = wallet;
        data["walletAmount"] = usedWalletAmount;
      }

      const subscriptionSuccess = () => {
        ReactPixel.track('Subscribe', { currency: "INR", value: calculatedAmount });
        window.gtag('event', 'conversion', {
          'send_to': 'AW-312869085/DRDYCIzCtskDEN2BmJUB',
          'value': calculatedAmount,
          'currency': 'INR'
        });
        localStorage.setItem("SUBSCRIBED", JSON.stringify(true));
        handleShow();
        localStorage.removeItem("ADD_PAGE");
        setSubscribeLoder(false);
        setCuponAmount(0);
        setCupon(false);
        setCuponCode("");
      };

      const subscriptionFailed = (errmsg) => {
        setSubscribeLoder(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errmsg,
        });
      };
      console.log(data);
      dispatch(SubscribeUser(data, subscriptionSuccess, subscriptionFailed));
    };

    const modalClose = () => {
      setSubscribeLoder(false);
    };
    razorpayPaymentHelper(data, onSuccess, modalClose);
  };

  // console.log(planDetails)
  //StripeData
  const userData = time_zone.timezone;
  const val = userData.split("/");
  var Stripedata = {
    amount: time_zone.country === "IN" ? grandTotal : grandTotal / 100,
    txndesc: planDetails?.courseName,
    currency: time_zone.country === "IN" ? "INR" : "USD",
    source: getDevice(),
    address: {
      line1: "default",
      postal_code: "default",
      city: "default",
      state: "default",
      country: time_zone.country
    },
    notes: {
      subscriptionName: planDetails?.courseName,
      desc: planDetails?.courseName,
      device: getDevice(),
      learnerID: User?._id,
      learner: User?._id,
      planId: planDetails?._id,
      month: parseInt(month),
      amount: time_zone.country === "IN" ? grandTotal : grandTotal / 100,
      zone1: val[0],
      zone2: val.length > 1 ? val[1] : undefined,
      isNewSchema: "true"
    }
  }

  if (cuponCode) {
    Stripedata.notes["influencer"] = cuponCode;
  }
  if (wallet) {
    Stripedata.notes["isWallet"] = wallet;
    Stripedata.notes["walletAmount"] = usedWalletAmount;
  }

  return (
    <div className="plan_price_container">
      <SubscriptionMessageModal show={show} handleClose={handleClose} />
      {/* <hr className="line"></hr> */}
      <div className="session_card content pt-5 pt-md-2">
        <div className="card mx-auto">
          <div className="d-md-flex">
            <div className="plan-details">
              <div className="duration">
                <h6>Select Duration</h6>
                <div className="d-md-flex p-2">
                  {content ? (
                    <>
                      <div className="dropdown m-1">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMinute"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {duration} per session
                        </button>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMinute"
                        >
                          {content.durations.map((data, i) => (
                            <span
                              className="dropdown-item"
                              key={i}
                              onClick={() => setDuration(data)}
                            >
                              {data} per session
                            </span>
                          ))}
                        </div>
                      </div>

                      <div className="dropdown m-1">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownWeek"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {day} day per week
                        </button>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownWeek"
                        >
                          {content.frequencies.map((data, i) => (
                            <span
                              className="dropdown-item"
                              key={i}
                              onClick={() => setDay(data)}
                            >
                              {data} day per week
                            </span>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-center mx-auto m-5">
                      <Loder />
                    </div>
                  )}
                </div>
              </div>

              <div className="target mt-2 p-2 mt-md-4">
                <h6>Select Target</h6>

                {content ? (

                  content.months.sort((x, y) => { return y.no - x.no }).map((data, i) => (

                    <div key={i}>
                      <input
                        type="radio"
                        id={data.no + "plan"}
                        value={data.no}
                        onChange={(e) => {
                          setMonth(e.target.value);
                          setDiscount(data.discount);
                        }}
                        name="radio-group"
                      />
                      <label
                        className={`price-card mt-3 ${month === data.no.toString()
                          ? "active-price-card "
                          : ""
                          }`}
                        htmlFor={data.no + "plan"}
                      >
                        <div className="d-flex justify-content-between price-card-body">
                          <div>
                            <h4>{data.no} Month</h4>
                            <p>
                              No. of sessions:{" "}
                              <strong>{data.no * day * 4}</strong>
                            </p>
                          </div>
                          <h3 className="price my-auto">
                            <strong>
                              {planDetails
                                ? time_zone.country === "IN"
                                  ? "₹ " +
                                  Math.round(
                                    planDetails.originalPrice -
                                    (planDetails.originalPrice / 100) *
                                    data.discount
                                  )
                                  : currencyConverter(
                                    Math.round(
                                      planDetails.originalPrice -
                                      (planDetails.originalPrice / 100) *
                                      data.discount
                                    ) / usdPrice
                                  )
                                : 0}
                            </strong>
                            /mth.
                          </h3>
                        </div>
                        {
                          data.no === 6 || data.no === 12 ?
                            <span className="badge">MOST SELECTED</span>
                            : ""
                        }

                        <span className="label">SAVE {data.discount}%</span>
                      </label>
                    </div>
                  ))
                ) : (
                  <div className="text-center m-5">
                    <Loder />
                  </div>
                )}
              </div>
            </div>
            <div className="billing">
              <h6>BILL SUMMARY</h6>
              <div className="summery mt-4">
                <div className="d-flex justify-content-between">
                  <p>Sub-Total :</p>
                  <p>
                    {time_zone.country === "IN"
                      ? "₹" +
                      new Intl.NumberFormat().format(
                        Math.round(planDetails?.originalPrice * month)
                      )
                      : currencyConverter(
                        Math.round(planDetails?.originalPrice * month) /
                        usdPrice
                      )}
                  </p>
                </div>

                {time_zone.country === "IN" ?
                  <div className="d-flex justify-content-between">
                    <p>GST Charges(18%) :</p>
                    <p> ₹ {new Intl.NumberFormat().format(gstAmount)}</p>
                  </div>
                  : ""
                }


                <div className="d-flex justify-content-between">
                  <p className="discount">Discount({discount + "%"}):</p>
                  <p className="discount">
                    {" "}
                    {time_zone.country === "IN"
                      ? "-₹" + new Intl.NumberFormat().format(discountAmount)
                      : currencyConverter(discountAmount / usdPrice)}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="d-flex">
                    <p>
                      Wallet (
                      {time_zone.country === "IN"
                        ? "₹" + walletAmount
                        : currencyConverter(walletAmount / usdPrice)}
                      ) :
                    </p>
                    <label className="checkbox_container ml-3">
                      <input
                        className="my-auto"
                        type="checkbox"
                        onClick={handleCheck}
                        checked={wallet}
                      />
                    </label>
                  </div>
                  <p>
                    {wallet
                      ? time_zone.country === "IN"
                        ? "-₹" + usedWalletAmount
                        : currencyConverter(usedWalletAmount / usdPrice)
                      : "-₹0"}
                  </p>
                </div>
                <div className="d-flex justify-content-between">

                  <p className="cupon"> {cupon ? "Coupon/Refferal applied" : "Apply Coupon/Refferal?"}:</p>
                  <p>
                    {cupon
                      ? time_zone.country === "IN"
                        ? "-₹" + new Intl.NumberFormat().format(cupondiscount)
                        : currencyConverter(cupondiscount / usdPrice)
                      : "-₹0"}
                  </p>
                </div>

                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    value={cuponCode}
                    onChange={(e) => setCuponCode(e.target.value)}
                    disabled={cupon}
                    placeholder="Apply Coupon/Refferal"
                  />
                  <div className="input-group-append">
                    {cupon ? (
                      <button
                        style={{ backgroundColor: "red" }}
                        className="btn cupon-btn"
                        type="button"
                        disabled={cuponLoder}
                        onClick={() => removeCupon()}
                      >
                        Remove
                      </button>
                    ) : (
                      <button
                        style={{ backgroundColor: "#4DC591" }}
                        className="btn cupon-btn"
                        type="button"
                        disabled={cuponLoder}
                        onClick={() => ApplyCupon()}
                      >
                        {" "}
                        {cuponLoder ? "Applying.." : "Apply"}
                      </button>
                    )}
                  </div>
                </div>

                {cuponLoder ? "Loading" : <p style={{ color: "#4DC591" }}>{cuponapplied}</p> }
                {/* {cuponapplied ? <p style={{ color: "#4DC591" }}>{cuponapplied}</p> : ""} */}

                <hr />
                <div className="d-flex justify-content-between grand-total">
                  <p className="grand-total">Grand Total :</p>
                  <p>
                    {time_zone.country === "IN"
                      ? "₹" + new Intl.NumberFormat().format(grandTotal)
                      : currencyConverter(grandTotal / 100)}
                  </p>
                </div>
              </div>

              <div className="make-payment mt-3">
                <h6>MAKE PAYMENT USING</h6>

                <div className="d-md-flex justify-content-between mt-3">
                  <div
                    className={`payment-selector ${paymentMethod === "Razorpay" ? `active` : ""
                      }`}
                  >
                    <input
                      type="radio"
                      id="razorpay"
                      value="Razorpay"
                      name="radio-group"
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      checked={paymentMethod === "Razorpay"}
                    />
                    <label htmlFor="razorpay">
                      <img src={rzpsvg} className="mt-2" alt="razorpay" />
                    </label>
                  </div>
                  <div
                    className={`payment-selector ${paymentMethod === "Stripe" ? `active` : ""
                      }`}
                  >
                    <input
                      type="radio"
                      id="stripe"
                      value="Stripe"
                      name="radio-group"
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      checked={paymentMethod === "Stripe"}
                    />
                    <label htmlFor="stripe">
                      <img src={stripesvg} className="mt-2" alt="stripe" />
                    </label>
                  </div>
                </div>
                <div className=" text-center mt-3">
                  {paymentMethod === "Razorpay" ? (
                    <>
                      <button
                        id="makepaymentid"
                        className="payment_btn mx-auto mt-2"
                        disabled={subscribeLoder}
                        onClick={() => SubscribeClapingo(grandTotal)}
                      >
                        {subscribeLoder
                          ? "Processing..."
                          : "Proceed to Payment"}
                      </button>
                      {/* <p className="mt-2" style={{ fontSize: "13px" }}>
                      EMI options available
                    </p> */}
                    </>
                  ) : (

                    <div className="  text-center mx-auto">

                      <StripePaymentHandler data={Stripedata} />
                    </div>
                  )}

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanAndPrices;
